import { cn } from "@/lib/utils";

export function Badge({
  children,
  tone = "default",
}: {
  children: React.ReactNode;
  tone?: "default" | "success" | "warning";
}) {
  const toneClasses = {
    default: "bg-navy-secondary text-text-secondary border-border",
    success: "bg-status-success/10 text-status-success border-status-success/30",
    warning: "bg-status-warning/10 text-status-warning border-status-warning/30",
  }[tone];

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-3 py-1 text-[11px] font-medium uppercase tracking-wide",
        toneClasses
      )}
    >
      {children}
    </span>
  );
}
